import {
  Button,
  ButtonColor,
  Loading,
  Overlay,
  RefreshContainer,
  Touchable,
  useRefAutoUpdate,
  WithNativeHTMLProps,
} from "@kalyzee/kast-web-sdk/web-components";
import { Meeting } from "@kalyzee/kast-web-sdk/websocket";
import React, { ForwardedRef, useEffect, useRef, useState } from "react";
import styles from "./PauseView.module.css";
import html2canvas from "html2canvas";
import { PausePopup, PausePopupApprenant, PausePopupPedagogy } from "@kalyzee/escaet-ui";

export interface PauseViewProps extends WithNativeHTMLProps<HTMLDivElement> {
  meeting: Meeting;
  back?: {
    text: string;
    subtext?: string;
    onClick?: () => void | Promise<void>;
  }
  onResume?: () => void | Promise<void>;
  onStop?: () => void | Promise<void>;
  hide?: boolean;
  className?: string;
  style?: React.CSSProperties;
  mode?: "expert" | "pedagogy" | "student";
}

export interface PauseViewRef {}

const PauseView = React.forwardRef(
  ({ meeting, back, onResume, onStop, hide = false, className, style, mode = "student", ...nativeProps }: PauseViewProps, forwardRef: ForwardedRef<PauseViewRef | undefined>) => {
    const defaultDateRef = useRef<Date>();
    // ---------------------------------------------------------------------- //
    // ---------------------------  RENDER ----------------------------- //
    // ---------------------------------------------------------------------- //

    if (hide) return null;

    const pausedAt = (meeting?.pausedAt ? new Date(meeting.pausedAt) : undefined) ?? defaultDateRef.current ?? new Date();
    const startedAt = meeting?.startedAt ? new Date(meeting.startedAt) : new Date();

    const classes = [styles.container];
    if (className) classes.push(className);

    if (mode === "expert") {
      return (
        <PausePopup
          startDate={pausedAt}
          startCourseDate={startedAt}
          onResume={(() => {
            onResume?.();
          }) as any}
          onClose={() => {
            onStop?.();
          }}
        />
      );
    }

    if (mode === "pedagogy") {
      return (
        <PausePopupPedagogy
          startDate={pausedAt}
          startCourseDate={startedAt}
          back={back}
          onResume={(() => {
            onResume?.();
          }) as any}
          onClose={() => {
            onStop?.();
          }}
        />
      );
    }

    return (
      <PausePopupApprenant
        startDate={pausedAt}
        startCourseDate={startedAt}
      />
    )
  }
);

export default PauseView;
